// extracted by mini-css-extract-plugin
export default {"gpa__login":"LoginButton_gpa__login__vgnGw","gpa__active_link":"LoginButton_gpa__active_link__OWyKH","gpa__dark_mode":"LoginButton_gpa__dark_mode__3Uc4E"};